var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.className,style:(`font-size:${_vm.fontSize}px`)},[_c('svg',{staticClass:"iconSymbol",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":'#' + _vm.icon}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }